import { __assign } from "tslib";
export var pluginConfig = function (config) {
    if (config === void 0) { config = {}; }
    return config.advanced
        ? __assign({ allowBackgroundColor: true, allowColumnResizing: true, allowHeaderColumn: true, allowHeaderRow: true, allowMergeCells: true, allowNumberColumn: true, stickToolbarToBottom: true, permittedLayouts: 'all', allowControls: true }, config) : config;
};
//# sourceMappingURL=create-plugin-config.js.map